import React, { Component } from 'react';
import './filters.scss';

export class CheckboxFilter extends Component {
    render() {
        const {checked, onChange, name, children} = this.props;
        return (
            <div className="filterItem">
                <input id={`filterInputName-${name}`} type="checkbox" name={name} onChange={onChange} checked={checked}/>
                <label htmlFor={`filterInputName-${name}`}>{children}</label>
            </div>
        )
    }
}

export class SearchFilter extends Component {
    render() {
        const {name, value, onChange, placeholder, clear} = this.props;
        const exists = this.refs.searchInput && this.refs.searchInput.value;

        return (
            <div className="nameFilter">
                <input type="text" name={name} value={value} ref="searchInput" onChange={onChange} placeholder={placeholder}/>
                <div className={`clearInput ${!exists && 'hide'} ${value.length === 0 && 'hide'}`} onClick={clear}></div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PageTemplate/Filters.jsx